export default "__VITE_ASSET__BveQ03TV__"